<template>
  <div
    class="base-checkbox"
    :class="{'base-checkbox--block': block}"
    @click.prevent.stop="onChange"
  >
    <span :class="`base-checkbox${disabled ? '' : '__button'}`">
      <base-icon
        :icon="icon"
        class="base-checkbox__icon"
      />
      <slot :label="label">
        <base-text
          class="base-checkbox__label"
          light
          :size="size"
          :class="customClass"
          inline
        >
          {{ label }}
        </base-text>
      </slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckbox',
  props: {
    label: {
      type: String,
      default: 'Label',
    },
    value: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    checkdisabled: {
      type: Boolean,
      default: false,
    },
    /** Now we have 2 checkbox. Orange and black */
    black: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    customClass() {
      const customClass = {
        'checkbox-disabled': this.checkdisabled,
      };

      return customClass;
    },
    icon() {
      const checked = this.black ? 'checked-black' : 'checked';
      const unchecked = this.black ? 'unchecked-black' : 'unchecked';
      if (this.checkdisabled) {
        return 'disabled-checkbox';
      }
      return this.value ? checked : unchecked;
    },
  },
  methods: {
    onChange() {
      if (this.disabled) {
        return;
      }
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.base-checkbox {
  display: inline-block;
  margin-right: 0.5rem;
  user-select: none;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }

  &__icon{
    margin-right: 0.5rem;
    pointer-events: none;
  }

  // &__button {
  // }
  &--block {
    display: block;
    margin-bottom: 0.5rem;
  }
}
.checkbox-disabled{
  font-family: 'SilkaLight';
  font-size: 14px;
  line-height: 135%;
  color: #C6C6C6;
}
</style>
